import * as React from "react";

import TableCell from "@material-ui/core/TableCell/TableCell";
import TableRow from "@material-ui/core/TableRow/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel/TableSortLabel";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";

function HouseholdPortfolioTableTableHeadRow({
  classes,
  columns,
  handleSort,
  order,
  orderBy,
  adminView,
}) {
  let createSortHandler = (property, extraOrdering) => (event) => {
    handleSort(event, property, extraOrdering);
  };

  return (
    <TableRow>
      {!adminView && <TableCell />}
      {columns.map((column, index) => {
        return (
          <TableCell
            key={index}
            align={column.numeric ? "right" : "left"}
            padding={column.disablePadding ? "none" : "default"}
            sortDirection={orderBy === column.id ? order : false}
            className={classes.onboardCell}
          >
            {column.sortable ? (
              <Tooltip
                title="Sort"
                placement={column.numeric ? "bottom-end" : "bottom-start"}
                enterDelay={300}
              >
                <TableSortLabel
                  active={orderBy === column.id}
                  direction={order}
                  onClick={createSortHandler(column.id, column.extraOrdering)}
                >
                  {column.label}
                </TableSortLabel>
              </Tooltip>
            ) : (
              column.label
            )}
          </TableCell>
        );
      })}
    </TableRow>
  );
}

export default HouseholdPortfolioTableTableHeadRow;



// WEBPACK FOOTER //
// ./src/containers/HouseholdDetail/components/PortfolioTable/components/TableHeadRow/index.jsx